module.exports = __webpack_public_path__ + "static/img/m-show-phone-2x.3c47590.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m-show-phone-2x.png
// module id = 215
// module chunks = 1 5